import { ActionReducerMap } from '@ngrx/store';
import * as fromCore from '@app/core/store/core.reducer'
import * as fromUsers from '@app/modules/users/store/reducers/user.reducer';
import * as fromSettings from '@app/modules/settings/store/reducers/settings.reducer';
import * as fromOrganization from '@app/modules/organization/store/reducers/organization.reducer';
import * as fromCounts from '@app/modules/counts/store/reducers/counts.reducer';
import * as fromProducts from '@app/modules/products/store/reducers/products.reducer';
import * as fromStorages from '@app/modules/storages/store/reducers/storages.reducer';
import * as fromImage from '@app/modules/image/store/reducers/image.reducer';
import * as fromIntegrations from '@app/modules/integrations/store/reducers/integrations.reducer';
import * as fromQuickBooks from '@app/modules/quick-books/store/reducers/quickbooks.reducer';
import * as fromPickings from '@app/modules/pickings/store/reducers/pickings.reducer';
import * as fromReceivings from '@app/modules/receivings/store/reducers/receivings.reducer';
import * as fromPicklists from '@app/modules/picklists/store/reducers/picklists.reducer';

import { ActionReducer, MetaReducer } from '@ngrx/store';

import LogRocket from 'logrocket';

const reduxMiddleware = LogRocket.reduxMiddleware();
export function logrocketMiddleware(reducer): ActionReducer<any, any> {
  let currentState;
  const fakeDispatch = reduxMiddleware({
    getState: () => currentState,
  })(() => {});

  return function (state, action) {
    const newState = reducer(state, action);
    currentState = state;
    fakeDispatch(action);
    return newState;
  };
}


export const appFeatureKey = 'AppState';

export const appReducer: ActionReducerMap<any> = {
  core: fromCore.reducer,
  settings: fromSettings.reducer,
  organization: fromOrganization.reducer,
  counts: fromCounts.reducer,
  products: fromProducts.reducer,
  storages: fromStorages.reducer,
  pickings: fromPickings.reducer,
  receivings: fromReceivings.reducer,
  picklists: fromPicklists.reducer,
  users: fromUsers.reducer,
  image: fromImage.reducer,
  integrations: fromIntegrations.reducer,
  quickBooks: fromQuickBooks.reducer
};

export function debug(reducer: ActionReducer<any>): ActionReducer<any> {
  return function(state, action) { 
    return reducer(state, action);
  };
}
 

export const metaReducers: MetaReducer<any>[] = [logrocketMiddleware,debug];


